export default "__VITE_ASSET__pUZelBnv__"